module.exports = __webpack_public_path__ + "img/title.dc6b7958.png";